import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutSalesStatusList extends Layout {
    layoutheaderSearchSalesStatuses: LayoutHeader;
    sourceSalesStatus: DataSource;
    tableStatuses: Table;
}
